module.exports = __webpack_public_path__ + "img/emoji-chat.9911fa4f.svg";